import { LoadTeleprompters } from '../../connection/teleprompters';
import { TeleprompterInterface, TeleprompterSectionInterface } from '../../types/interfaces';
import { Action, AsyncAction } from '../types/types';

// Connection actions
export const LOAD_TELEPROMPTERS = 'LOAD_TELEPROMPTERS';
export function loadTeleprompters(token: string, grUser: number, meeting: number): AsyncAction {
	return {
		type: LOAD_TELEPROMPTERS,
		promise: LoadTeleprompters(token, { gr_user: grUser, meeting }),
	};
}

export const SET_SELECTED_TELEPROMPTERS = 'SET_SELECTED_TELEPROMPTERS';
export function setSelectedTeleprompters(state: [string, number | null]) {
	return {
		type: SET_SELECTED_TELEPROMPTERS,
		payload: state,
	};
}

export const SAVE_TELEPROMPTER = 'SAVE_TELEPROMPTER';
export function saveTeleprompter(teleprompter: TeleprompterInterface): Action {
	return {
		type: SAVE_TELEPROMPTER,
		payload: teleprompter,
	};
}

export const UPDATE_SINGLE_TELEPROMPTER = 'UPDATE_SINGLE_TELEPROMPTER';
export function updateSingleTeleprompter(teleprompter: TeleprompterInterface): Action {
	return {
		type: UPDATE_SINGLE_TELEPROMPTER,
		payload: teleprompter,
	};
}

export const UPDATE_TELEPROMPTER_SECTION = 'UPDATE_TELEPROMPTER_SECTION';
export function updateTeleprompterSection(
	teleprompterId: number,
	section: TeleprompterSectionInterface,
): Action {
	return {
		type: UPDATE_TELEPROMPTER_SECTION,
		payload: { teleprompterId, section },
	};
}

export const REMOVE_TELEPROMPTER = 'REMOVE_TELEPROMPTER';
export function removeTeleprompter(teleprompterId: number): Action {
	return {
		type: REMOVE_TELEPROMPTER,
		payload: teleprompterId,
	};
}
